/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const FlightStatus = {
    Confirmed: 'confirmed',
    Cancelled: 'cancelled'
};
export function FlightStatusFromJSON(json) {
    return FlightStatusFromJSONTyped(json, false);
}
export function FlightStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FlightStatusToJSON(value) {
    return value;
}
